import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setSubjectFinalCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getSubjectFinalCount() {
            return HTTP.get('/kenya/subject_final_status/get_new_count');
        }
    },
}